import appSettings from '../appSettings';
import { logError, reactPlugin } from '../components/AppInsightsComponent';
import { postWithRetry } from '../utils/apiClient';

const EMAIL_TIMEOUT_MS = 30000;

export const sendClaimSummaryEmail = async (
  id,
  confirmationId,
  policyHolder,
  type
) => {
  const resolvedType = type ?? localStorage.getItem('policyType');

  try {
    reactPlugin.trackEvent({
      name: 'ClaimEmailSummaryActionsRcvd',
      properties: {
        'am-correlation-id': confirmationId,
        'am-component': 'emailActions.sendClaimSummaryEmail',
        'am-message': 'Claims Email request received in emailActions.',
      },
    });

    const {
      policyNumber,
      firstName,
      reporter,
      email,
      dateOfLoss,
      lossLocation,
    } = policyHolder;

    const fnolEmails = appSettings.FNOL_TEAM_EMAILS.split(',').map(
      (element) => ({
        email: element,
      })
    );

    const to = Array.isArray(email)
      ? email.map((element) => ({ email: element }))
      : [{ email }];

    const subject = policyNumber
      ? `American Modern Digital Claim Submission - Policy ${policyNumber}`
      : 'American Modern Digital Claim Submission';

    const payload = {
      htmlToPdf: {
        url: `${window.location.origin}/claims-fnol-search?id=${confirmationId}`,
        requiresAuth: false,
        width: '1200px',
        height: '1400px',
      },
      claim: {
        reporter,
        submissionId: id,
        dateOfLoss,
        lossLocation,
        type: resolvedType,
      },
      policyHolderEmail: {
        firstName,
        templateName: 'claim-reporter-email-template',
        to,
      },
      fnolTeamEmail: {
        templateName: 'fnol-team-email-template',
        fnolSummaryUrl: `${window.location.origin}/claims-fnol-search?id=${confirmationId}`,
        to: fnolEmails,
      },
      confirmationId,
      sender: {
        name: 'American Modern Insurance Group',
        email: 'noreply@amig.com',
      },
      subject,
      attachments: [],
    };

    const url = `${appSettings.DIGITAL_CLAIMS_PROXY_BASE_URL}/claims/email-summary?type=${encodeURIComponent(
      resolvedType ?? ''
    )}&id=${encodeURIComponent(confirmationId)}`;

    reactPlugin.trackEvent({
      name: 'CallEmailActions',
      properties: {
        'am-correlation-id': confirmationId,
        'am-component': 'emailActions.sendClaimSummaryEmail',
        'am-submission-id': id,
      },
    });

    const { response, attempt, duration } = await postWithRetry({
      url,
      payload,
      timeout: EMAIL_TIMEOUT_MS,
      headers: {
        'Content-Type': 'application/json',
        'x-am-correlation-id': confirmationId,
        'Idempotency-Key': confirmationId,
      },
      onAttemptFailure: ({ error, attempt, duration }) => {
        reactPlugin.trackEvent({
          name: 'CallEmailActionsFailed',
          properties: {
            'am-correlation-id': confirmationId,
            'am-component': 'emailActions.sendClaimSummaryEmail',
            'am-attempt': String(attempt),
            'am-code': error.code ?? 'none',
            'am-status': String(error.response?.status ?? 0),
            'am-duration-ms': String(duration),
          },
        });
      },
    });

    reactPlugin.trackEvent({
      name: 'CallEmailActionsResp',
      properties: {
        'am-correlation-id': confirmationId,
        'am-component': 'emailActions.sendClaimSummaryEmail',
        'am-status': String(response.status),
        'am-attempt': String(attempt),
        'am-duration-ms': String(duration),
      },
    });

    return { success: true, data: response.data };
  } catch (error) {
    logError(error, 'emailActions.sendClaimSummaryEmail', {
      'am-correlation-id': confirmationId,
    });

    return { success: false, error };
  }
};